import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Seo } from "@/components/site/Seo";
import { Scribble, Star } from "@/components/site/Doodles";

const inputCls = "w-full rounded-2xl border-2 border-purple-500/30 bg-black/40 px-4 py-3 text-white outline-none focus:border-[var(--km-pink)]";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(errMsg(err, "مش قادرين نسجل دخول"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="km-grid-bg relative grid min-h-screen place-items-center overflow-hidden px-4" data-testid="admin-login-page">
      <Seo title="دخول الإدارة" noindex />
      <Scribble className="km-wiggle absolute right-10 top-10 h-24 w-24 opacity-60" />
      <Star className="km-float absolute bottom-16 left-16 h-12 w-12" />
      <form onSubmit={submit} className="relative w-full max-w-md space-y-5 rounded-[2rem] border border-purple-500/30 bg-[var(--km-bg2)] p-8 shadow-2xl" data-testid="admin-login-form">
        <img src="/logo-purple.png" alt="خرابيش موشن" className="mx-auto mb-2 h-20 w-auto rounded-2xl bg-white px-4 py-2" />
        <div className="mb-2 flex items-center gap-3">
          <span className="grid h-12 w-12 place-items-center rounded-2xl bg-[var(--km-purple)]"><Lock className="h-6 w-6 text-white" /></span>
          <div>
            <h1 className="font-display text-3xl text-white">لوحة التحكم</h1>
            <p className="text-sm text-purple-300/70">خرابيش موشن · للمالك بس</p>
          </div>
        </div>
        <label className="block">
          <span className="font-head mb-1.5 block text-sm font-bold text-white">الإيميل</span>
          <input className={`${inputCls} text-right`} dir="ltr" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email-input" />
        </label>
        <label className="block">
          <span className="font-head mb-1.5 block text-sm font-bold text-white">كلمة السر</span>
          <input className={`${inputCls} text-right`} dir="ltr" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password-input" />
        </label>
        {error && <p className="rounded-xl bg-red-500/10 px-3 py-2 text-sm text-red-300" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} data-testid="admin-login-submit-btn"
          className="font-head flex w-full items-center justify-center gap-2 rounded-full bg-[var(--km-pink)] py-3.5 font-bold text-white transition-opacity disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} دخول
        </button>
      </form>
    </div>
  );
}
